{
  "acsSlow": {
    "body": "Povezujemo vas s ponudnikom vašega plačilnega sredstva za odobritev transakcije.",
    "title": "Čakanje na odgovor vaše banke ..."
  },
  "app": {
    "title": "Plačajte obvestilo – pagoPA"
  },
  "ariaLabels": {
    "appLanguage": "Nastavite jezik",
    "close": "Zapri",
    "editCard": "Spremenite podatke kartice",
    "editDonation": "Spremenite prejemnika donacije",
    "editPsp": "Spremenite ponudnika plačilnih storitev",
    "informationDialog": "Informacije o stroških provizije",
    "informationLink": "Izvedite več o kampanji",
    "languageMenu": "Nastavljen jezik",
    "loading": "Nalaganje",
    "applySorting": "Uporabi izbrani vrstni red",
    "sortingDefault": "Privzeto razvrščanje",
    "sortingName": "Razvrščanje po imenu",
    "sortingAmount": "Razvrščanje po znesku"
  },
  "cancelledPage": {
    "body": "Postopek je bil preklican",
    "button": "Zapri"
  },
  "authCallbackPage": {
    "title": "Ni bilo mogoče dostopati",
    "body": "Prišlo je do težave med dostopom. Poskusi znova čez nekaj minut.",
    "buttons": {
      "retry": "Poskusi znova",
      "continueWithoutLogin": "Nadaljuj brez prijave"
    }
  },
  "authExpiredPage": {
    "title": "Tvoja seja je potekla",
    "body": "Prijavi se za nadaljevanje seje ali nadaljuj brez prijave ",
    "buttons": {
      "login": "Prijava",
      "continueWithoutLogin": "Nadaljuj brez prijave."
    }
  },
  "cartDetail": {
    "amount": "Znesek",
    "companyName": "Upnik",
    "description": "Namen plačila",
    "fiscalCode": "Davčna številka upnika",
    "iuv": "IUV koda",
    "noticeNumber": "Št. obvestila"
  },
  "clipboard": {
    "copied": "Kopirano",
    "copy": "Kopiraj",
    "edit": "Spremeni"
  },
  "DOMAIN_UNKNOWN": {
    "title": "Upnik ima težave z odzivom",
    "buttons": {
      "close": "Zapri",
      "help": "Obrnite se na podporo"
    }
  },
  "DONATIONLIST_ERROR": "Seznama organizacij ni bilo mogoče naložiti.",
  "donationPage": {
    "click": "pritisnite",
    "code": "in uokvirite kodo:",
    "description": "Časa imate do 23. decembra. Donacijo lahko nakažete s kartico brez stroškov provizije. Znesek bo nakazan neposredno na račun organizacije, ki ji ste jo izbrali za nakazilo donacije.",
    "dismissCTA": "Oglejte si organizacije",
    "dismissDescription": "Če želite, lahko donirate eni od humanitarnih organizacij, ki so se pridružile pobudi.",
    "dismissTitle": "Storitev ni več aktivna",
    "entity": "Komu želite nakazati donacijo?",
    "ioDescription": "Donacijo nakažite z aplikacijo IO, da prejmete elektronsko pošto s podatki za namene davčnih olajšav.",
    "modalBody2": "S svojimi karticami lahko donirate brez stroškov provizije.",
    "modalTitle": "Nadaljujte do aplikacije IO",
    "openSection": "Odprite razdelek",
    "payNotice": "Plačajte obvestilo",
    "portfolio": "Denarnica",
    "submitCard": "Donirajte s kartico",
    "submitIO": "Donirajte z IO",
    "title": "Donirajte za krizo v Ukrajini",
    "volunteer": "Koliko želite donirati?"
  },
  "errorButton": {
    "close": "Zapri",
    "help": "Obrnite se na podporo",
    "retry": "Poskusite znova"
  },
  "ErrorCodeDescription": "Koda napake za podporo",
  "GENERIC_ERROR": {
    "body": "Poskusite znova ali se obrnite na podporo.",
    "title": "Prišlo je do nepričakovane napake"
  },
  "general": {
    "and": "in"
  },
  "indexPage": {
    "description": "Svojo kartico, račun ali plačilno aplikacijo lahko uporabite. Rezultat plačila boste prejeli po elektronski pošti.",
    "title": "Plačajte obvestilo"
  },
  "iframeCardPage": {
    "helpLink": "Kje najdem CVV?",
    "modalTitle": "Kje najdem CVV?",
    "modalBodyText": "Koda CVV (ali CVC) ima 3 številke in jo najdete na zadnji strani svoje kartice.<br>Na karticah American Express ima koda (CID) 4 številke in je na sprednji strani.",
    "buttonClose": "Zapri"
  },
  "inputCardPage": {
    "formErrors": {
      "cid": "Vnesite 4-mestna številka",
      "cvv": "Vnesite 3-mestna številka",
      "expirationDate": "Vnesite mm/ll",
      "name": "Vnesite, kot je navedeno na kartici",
      "number": "Vnesite veljavno številko",
      "required": "Zahtevano polje"
    },
    "formFields": {
      "cid": "CID (4-mestna številka)",
      "cvv": "CVV",
      "expirationDate": "Velja do",
      "name": "Imetnik kartice",
      "number": "Številka kartice",
      "required": "Zahtevano polje"
    },
    "helpLink": "Kje najdem varnostno kodo?",
    "modal": {
      "description": "To je trimestna številka, imenovana CVV ali CVS, ki je navedena na zadnji strani kartice.",
      "descriptionAE": "Na karticah American Express je številka (CID) štirimestna in je navedena na sprednji strani.",
      "title": "Varnostna številka"
    },
    "title": "Vnesite podatke o kartici"
  },
  "INVALID_CARD": {
    "body": "Poskusite vnesti veljavno kartico ali se obrnite na našo podporo.",
    "title": "Vaša kartica je neveljavna"
  },
  "INVALID_DECODE": {
    "body": "Poskusite znova ali se obrnite na našo podporo.",
    "title": "Med branjem podatkov je prišlo do napake"
  },
  "INVALID_QRCODE": {
    "body": "Če težave ne morete odpraviti, poskusite podatke vnesti ročno.",
    "title": "Uokvirjena koda ni obvestilo pagoPA"
  },
  "koPage": {
    "body": "Noben znesek ni bil zaračunan.",
    "button": "Zapri",
    "helpButton": "Potrebujete pomoč?",
    "learnMoreButton": "Izvedite več",
    "title": "Prišlo je do nepričakovane napake"
  },
  "mainPage": {
    "footer": {
      "accessibility": "Dostopnost",
      "help": "Pomoč",
      "privacy": "Zasebnost",
      "terms": "Pogoji",
      "platformStatus": "Stanje platforme",
      "pagoPA": "Obiščite spletno stran pagoPA"
    },
    "header": {
      "login": "Prijava",
      "logout": "Izhod",
      "detail": {
        "detailButton": "Odpri povzetek plačila",
        "detailFC": "Davčna številka upnika",
        "detailIUV": "IUV Koda",
        "detailAmount": "Vmesni seštevek",
        "detailReceiver": "Upnik",
        "detailSubject": "Namen plačila",
        "detailTitle": "Podrobnosti o obvestilu"
      },
      "disclaimer": "Znesek se samodejno posodobi, zato vedno plačate le kar dolgujete in se izognete zamudnim ali drugim obrestim."
    },
    "main": {
      "skipToContent": "Preskoči na glavno vsebino"
    }
  },
  "NOTLISTED": {
    "body": "Poskusite znova ali se obrnite na našo podporo.",
    "title": "Prišlo je do nepričakovane napake"
  },
  "PAYMENT_CANCELED": {
    "body": "Za več informacij se obrnite na upnika.",
    "title": "Upnik je to obvestilo preklical"
  },
  "PAYMENT_DATA_ERROR": {
    "title": "Podatki obvestila niso pravilni"
  },
  "PAYMENT_DUPLICATED": {
    "body": "Če ste plačali na tem spletnem mestu, je bilo potrdilo poslano na elektronski naslov, ki ste ga navedli ob zaključku nakupa.",
    "title": "To obvestilo je že plačano!"
  },
  "PAYMENT_EXPIRED": {
    "body": "Za več informacij se obrnite na upnika.",
    "title": "Obvestilo je poteklo in ga ni več mogoče plačati"
  },
  "PAYMENT_ONGOING": {
    "body": "Če težave ne morete odpraviti, nam to sporočite!",
    "title": "Plačilo že poteka, poskusite znova kasneje"
  },
  "PAYMENT_UNAVAILABLE": {
    "title": "To obvestilo vsebuje tehnično težavo"
  },
  "PAYMENT_UNKNOWN": {
    "body": "Obvestilo bi lahko bilo že plačano. Za pomoč se obrnite na Upnika.",
    "title": "Obvestila ni bilo mogoče najti"
  },
  "pspUnavailable": {
    "body": "Do te napake lahko pride, če je znesek za plačilo posebej visok ali če poskušate plačati digitalni davčni žig.",
    "cta": {
      "primary": "Izberite drug način plačila"
    },
    "title": "Izbrani način plačila ni na voljo"
  },
  "paymentEmailPage": {
    "description": "Na ta naslov boste prejeli rezultat plačila",
    "formButtons": {
      "back": "Nazaj",
      "submit": "Nadaljuj"
    },
    "formErrors": {
      "invalid": "Vnesite veljaven elektronski naslov",
      "notEqual": "E-poštna naslova se ne ujemata",
      "required": "Zahtevano polje"
    },
    "formFields": {
      "confirmEmail": "Ponovite še enkrat",
      "email": "Elektronski naslov"
    },
    "title": "Vnesite svoj elektronki naslov"
  },
  "findOutMoreModal": {
    "title": "Kaj storiti, če plačilo ni uspešno?",
    "section1Title": "1. Plačaj obvestilo",
    "section1ContentRow1": "Ne pozabi plačati obvestila v predvidenem roku, ki ga določi organ.",
    "section1ContentRow2": "Če prek tega spletnega mesta ne uspe, ",
    "section1ContentRow2Link": "poišči druge kanale, ki so omogočeni za pagoPA.",
    "section2Title": "2. Počakaj na vračilo.",
    "section2ContentRow1": "Običajno je znesek povrnjen v nekaj minutah.",
    "section2ContentRow2": "V drugih primerih lahko prenos denarja na tvoj račun ali kartico traja dlje časa.",
    "section3Title": "3. Kontaktiraj podporo uporabnikom.",
    "section3ContentRow1": "Če po 5 delovnih dneh še nisi prejel vračila, ",
    "section3ContentRow2Link": "kontaktiraj podporo uporabnikom."
  },
  "paymentResponsePage": {
    "0": {
      "body": "Potrdilo o plačilu smo poslali na {{useremail}}",
      "title": "Plačali ste {{amount}}"
    },
    "1": {
      "body": "Noben znesek ni bil zaračunan.",
      "title": "Prišlo je do nepričakovane napake."
    },
    "2": {
      "body": "Noben znesek ni bil zaračunan. Preverite, ali ste pravilno upoštevali navodila svoje banke.",
      "title": "Avtorizacija zavrnjena"
    },
    "3": {
      "body": "Če ste plačali z debetno ali kreditno kartico, se prepričajte, da ste vnesli svoje podatke, ki so navedeni na sprednji strani.",
      "title": "Podatki o načinu plačila niso pravilni"
    },
    "4": {
      "body": "Noben znesek ni bil zaračunan. Zaradi vaše varnosti imate omejen čas za dokončanje postopka.",
      "title": "Seja je potekla"
    },
    "5": {
      "title": "Mreža plačilnih kartic ni podprta"
    },
    "6": {
      "title": "Za nadaljevanje s plačilom manjka nekaj podatkov"
    },
    "7": {
      "body": "Za več informacij se obrnite na svojo banko.",
      "title": "Način plačila je potekel ali ni več veljaven"
    },
    "8": {
      "body": "Noben znesek ni bil zaračunan.",
      "title": "Postopek je bil preklican"
    },
    "10": {
      "body": "Noben znesek ni bil zaračunan. Verjetno ste presegli limit porabe, ki ga je določila vaša banka.",
      "title": "Avtorizacija zavrnjena"
    },
    "12": {
      "title": "Način plačila ni podprt"
    },
    "17": {
      "body": "Rezultat plačila boste prejeli na naslov {{useremail}}.",
      "title": "Počakajte na potrditev plačila"
    },
    "18": {
      "body": "Dovoljeni znesek je bil vrnjen na tvoje plačilno sredstvo. Prenos denarja lahko traja nekaj časa.",
      "title": "Plačilo ni bilo uspešno"
    },
    "25": {
      "body": "Noben znesek ni bil zaračunan. \n Če težava vztraja, poskusi uporabiti drug način ali ponudnika plačila.",
      "title": "Plačilo ni bilo uspešno"
    },
    "116": {
      "body": "Noben znesek ni bil zaračunan. Preden poskusiš znova, dodaj sredstva na kartico ali uporabi drug način plačila.",
      "title": "Stanje na tvoji kartici ni dovolj"
    },
    "117": {
      "body": "Noben znesek ni bil zaračunan. Koda (CVV ali CVC) ima 3 številke in se nahaja na zadnji strani kartice. Če uporabljaš American Express, ima koda (CID) 4 številke in je na sprednji strani.",
      "title": "Vnesena varnostna koda je napačna"
    },
    "121": {
      "body": "Noben znesek ni bil zaračunan. Preden poskusiš znova, spremeni limit porabe ali uporabi drug način plačila.",
      "title": "Presegel si limit porabe na svoji kartici"
    },
    "3dsNotInitiated": {
      "body": "Noben znesek ni bil zaračunan.\nČe težave ne morete odpraviti, se obrnite na ponudnika plačilnega sredstva, na primer na banko.",
      "title": "Pri vašem ponudniku plačilnega sredstva je prišlo do težave"
    },
    "buttons": {
      "continue": "Nadaljuj",
      "findOutMode": "Izvedi več"
    },
    "survey": {
      "body": "Zaupajte nam svoje izkušnje s plačevanjem in nam pomagajte izboljšati se.",
      "link": {
        "href": "https://pagopa.qualtrics.com/jfe/form/SV_0jllXJcXhmSpb38",
        "text": "Pojdite na anketo"
      },
      "title": "Nam lahko poveste, kako je bilo?"
    }
  },
  "paymentCheckPage": {
    "buttons": {
      "cancel": "Prekliči",
      "submit": "Plačaj",
      "wait": "Počakaj ..."
    },
    "creditCard": "Plačajte z",
    "disclaimer": {
      "cheaper": "Priporočeno, ker je najcenejše",
      "yourCard": "Priporočeno, ker ste že stranka",
      "psp": "Z nadaljevanjem sprejemate <terms>Pogoje uporabe</terms> in potrjujete, da ste prebrali <privacy>Politiko zasebnosti družbe</privacy> <psp>{{pspName}}</psp>"
    },
    "drawer": {
      "body": "Na tem seznamu boste našli vse ponudnike, ki so združljivi z vašim načinom, tudi če niste njihova stranka.",
      "header": {
        "amount": "Provizija",
        "name": "Ponudnik"
      },
      "title": "Pri katerem ponudniku želite plačevati?",
      "selectPspAccessibilityLabel": "Izberite {{pspName}} kot ponudnika plačilnih storitev",
      "pspNameAccessibilityLabel": "Razvrsti po imenu ponudnika po abecednem vrstnem redu",
      "taxFeeAccessibilityLabel": "Razvrsti od najnižje provizije navzgor"
    },
    "email": "Rezultat pošlji na:",
    "modal": {
      "body": "Vsako denarno nakazilo (v gotovini ali elektronskem denarju) vključuje stroške, ki zagotavljajo, da je to plačilo varno in uspešno izvedeno.\nVsak ponudnik (ali ponudnik plačilnih storitev) predvideva stroške skladno s svojo poslovno politiko in pogodbenimi pogoji.\nPri pagoPA so ti stroški pregledni in državljan/-ka lahko prosto izbere najudobnejšo in najpriročnejšo možnost. Če želite izvedeti več, obiščite spletno stran ",
      "cancelBody": "Če odideš, bodo vsi doslej vneseni podatki izbrisani in začeti bo treba znova.",
      "cancelButton": "Ne, premislil/-a sem",
      "cancelTitle": "Tvoje plačilo je v obdelavi. Ali res želiš oditi?",
      "link": "Preglednost stroškov",
      "submitButton": "Izhod",
      "title": "Zakaj obstaja provizija?"
    },
    "psp": "Uporablja jo",
    "total": "Skupno",
    "transaction": "Provizija"
  },
  "paymentChoicePage": {
    "saved": "Shranjeni",
    "bank": "Bančni račun",
    "button": "Nazaj",
    "costs": "Preglednost stroškov.",
    "creditCard": "Debetna ali kreditna kartica",
    "description": "Če želite izvedeti več o načinih in stroških, ki jih uporabljajo sodelujoči upravljavci, obiščite spletno stran ",
    "incoming": "Prihajajo",
    "others": "Drugi načini",
    "showMore": "Nedosegljive metode",
    "title": "Kako želite plačati?",
    "feeRange": "Provizija: od {{min}}  do {{max}}",
    "feeSingle": "Provizija: {{value}}",
    "filterLabel": "Poišči metodo",
    "noPaymentMethodsAvailable": "Ni rezultatov. Poskusite z drugo ključno besedo.",
    "filterButton": "Filtriraj",
    "drawer": {
      "title": "Filtriraj načine plačila",
      "byType": "Po vrsti",
      "byFunc": "Po funkcionalnosti",
      "card": "Kartica",
      "balance": "Bančni račun",
      "appApm": "Aplikacije in drugi načini",
      "payByPlan": "Obročno plačilo",
      "showResults": "Prikaži rezultate",
      "remove": "Počisti vse filtre"
    }
  },
  "paymentMethods": {
    "bpay": "BANCOMAT Pay",
    "cc": "Bančni račun",
    "cp": "Debetna ali kreditna kartica",
    "ppay": "Plačajte s Postepay"
  },
  "paymentNoticeChoice": {
    "form": {
      "description": "Št. obvestila in davčna številka upnika",
      "title": "Podatke vnesite sami"
    },
    "qr": {
      "description": "Uporabite svojo spletno kamero ali kamero",
      "title": "Uokvirite kodo QR"
    }
  },
  "paymentNoticePage": {
    "description": "Vnesite podatke, kot so navedeni na obvestilu o plačilu.",
    "exampleModalAltText": "Obvestilo o plačilu pagoPA, s poudarkom na delu, kjer sta navedena koda obvestila in davčna številka upnika",
    "exampleModalTitle": "Primer obvestila pagoPA",
    "formButtons": {
      "cancel": "Nazaj",
      "submit": "Nadaljuj"
    },
    "formErrors": {
      "minCf": "Vnesite 11-mestno številko",
      "minCode": "Vnesite 18-mestno številko",
      "required": "Zahtevano polje"
    },
    "formFields": {
      "billCode": "Št. obvestila",
      "cf": "Davčna številka upnika"
    },
    "helpLink": "Oglejte si primer",
    "title": "Kaj morate plačati?"
  },
  "paymentPspListPage": {
    "title": "Izberite, kdo bo upravljal plačilo",
    "description": "Vsak ponudnik predlaga provizijo. Na tem seznamu najdete vse združljive ponudnike, <strong>tudi če niste njihova stranka</strong>.",
    "operator": "Ponudnik",
    "alreadyClient": "Že ste stranka",
    "formButtons": {
      "back": "Nazaj",
      "submit": "Nadaljuj"
    },
    "sort": "Razvrsti",
    "drawer": {
      "sorting": {
        "default": "Privzeto",
        "name": "Po imenu",
        "amount": "Po znesku"
      },
      "showResults": "Uporabi"
    },
    "myBankAlertTitle": "Ne najdete svoje banke?",
    "myBankAlertBody": "Ne skrbite: v naslednjih korakih jo boste morali izbrati."
  },
  "paymentQrPage": {
    "camBlocked": "Za uporabo kamere potrebujemo vaše soglasje. Če želite spremeniti svojo izbiro, pojdite na nastavitve zasebnosti v svojem brskalniku",
    "description": "Poskrbite za dobro osvetlitev. Če koda ni izostrena, poskusite telefon rahlo odmakniti od zaslona.",
    "navigate": "Ne deluje? Vnesite ročno",
    "reloadPage": "Ponovno naloži stran",
    "title": "Uokvirite kodo QR",
    "usageHintPc": "Ta stran zahteva uporabo bralnika QR kod. Za skeniranje QR kode dovoli brskalniku dostop do kamere, ko bo zahtevano. Morda boš moral uporabiti zunanjo ali vgrajeno spletno kamero. QR koda mora biti dobro uokvirjena in osvetljena, da bo njeno branje lažje.",
    "usageHintMobile": "Ta stran zahteva uporabo bralnika QR kod. Za skeniranje QR kode dovoli brskalniku dostop do kamere, ko bo zahtevano. Uporabi zadnjo kamero svojega pametnega telefona in jo usmeri proti QR kodi. QR koda mora biti dobro uokvirjena in osvetljena, da bo njeno branje lažje."
  },
  "paymentSummaryPage": {
    "amount": "Posodobljeni znesek",
    "billCode": "Št. obvestila",
    "buttons": {
      "cancel": "Nazaj",
      "ok": "V redu",
      "submit": "Pojdite na plačilo"
    },
    "causal": "Namen plačila",
    "cf": "Davčna številka upnika",
    "creditor": "Upnik",
    "description": "Ko se znesek spremeni, to pomeni, da je bil samodejno posodobljen. Če je višji, lahko vključuje obresti, kazni ali stroške obvestila.\n\nČe obvestilo pagoPA zadeva pravno veljavno komunikacijo, je lahko povečanje zneska za plačilo odvisno od različnih dejavnikov, na primer:\n• če ste prejeli obvestilo s priporočeno pošto (stroški tiskanja in pošiljanja so lahko na breme prejemnika);\n• število poskusov dostave.\n\nZa dodatne podrobnosti se obrnite na upni organ.",
    "dialog": {
      "description": "Ko se znesek spremeni, to pomeni, da je bil samodejno posodobljen. Če je višji, lahko vključuje obresti, kazni ali stroške obvestila.\n\nČe obvestilo pagoPA zadeva pravno veljavno komunikacijo, je lahko povečanje zneska za plačilo odvisno od različnih dejavnikov, na primer:\n• če ste prejeli obvestilo s priporočeno pošto (stroški tiskanja in pošiljanja so lahko na breme prejemnika);\n• število poskusov dostave.\n\nZa dodatne podrobnosti se obrnite na upni organ.",
      "title": "Je znesek drugačen od tistega na obvestilu pagoPA?"
    },
    "iuv": "IUV koda",
    "title": "Podatki o plačilu"
  },
  "POLLING_SLOW": {
    "body": "Počakajte največ nekaj minut, ne da bi medtem ponovno naložili stran.",
    "title": "Upnik potrebuje več časa od pričakovanega ..."
  },
  "privacyInfo": {
    "googleDesc": "Obrazec zaščiten z reCAPTCHA in Googlom.",
    "privacyDesc": "Z nadaljevanjem sprejemate <terms>Pogoje in določila uporabe</terms> storitve in potrjujete, da ste prebrali <privacy>Politiko varovanja zasebnosti</privacy>",
    "privacyDonation": "Dodatne pogoje storitve Donacije za krizo v Ukrajini"
  },
  "STATUS_ERROR": {
    "body": "Če težave ne morete odpraviti, nam to sporočite!",
    "title": "Prišlo je do nepričakovane napake"
  },
  "TIMEOUT": {
    "body": "Če težave ne morete odpraviti, nam to sporočite!",
    "title": "Upnik ima težave z odzivom"
  },
  "errorMessageNPG": {
    "HF0001": "Vnesite 3 ali 4 mestna",
    "HF0002": "Storitev začasno ni na voljo",
    "HF0003": "Seja je potekla, pojdite nazaj in poskusite znova",
    "HF0004": "Vnesite veljavno številko",
    "HF0005": "Omrežje te kartice ni podprto",
    "HF0006": "Vnesite mm/ll",
    "HF0007": "Vnesite, kot je navedeno na kartici",
    "HF0009": "Preverjanje 3DS ni uspelo"
  },
  "userSession": {
    "logoutModal": {
      "title": "Ali res želiš oditi?",
      "body": "Plačati boš lahko tudi brez prijave.",
      "submitButton": "Izhod",
      "cancelButton": "Prekliči"
    }
  },
  "ScheduledMaintenanceBanner": {
    "titleKey": "Načrtovano vzdrževanje",
    "bodyKey": "Plačilo ne bo mogoče od 00:01 do 03:00 dne 18. julija 2025.",
    "linkTextKey": "Več informacij"
  },
  "maintenancePage": {
    "title": "Delamo za vas",
    "subtitle": "pagoPa trenutno ni na voljo zaradi načrtovanega vzdrževanja.",
    "closeButton": "Zapri",
    "detailsButton": "Izvedi več"
  },
  "__variant-name": "Sloveno",
  "__variant-description": ""
}